var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDragAndDrop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 10.5,
  r: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 10.5,
  r: 1.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 16.5,
  r: 1.5
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 16.5,
  r: 1.5
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 22.5,
  r: 1.5
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 22.5,
  r: 1.5
})));
export default SvgIcDragAndDrop;